module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-quick-search",
    on: {
      "focusout": _vm.handleFocusout
    }
  }, [_c('a', {
    staticClass: "fa-stack fa-lg",
    on: {
      "click": function($event) {
        _vm.searchOpen = !_vm.searchOpen
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x"
  }), _c('i', {
    staticClass: "fa fa-search fa-stack-1x fa-inverse"
  })]), (_vm.searchOpen) ? [_c('div', {
    staticClass: "search-container"
  }, [_c('div', {
    staticClass: "search mt-2 card"
  }, [_c('SearchEntity', {
    staticClass: "mb-1",
    attrs: {
      "entity": "clients"
    },
    on: {
      "selected": function($event) {
        return _vm.gotoEntity($event, 'clients')
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(result) {
        return [_c('div', {
          staticClass: "quick-search-result"
        }, [_c('div', [_c('small', [_vm._v("CL" + _vm._s(result.result.id))]), _c('div', [_vm._v(_vm._s(result.result.name) + " " + _vm._s(result.result.surname))]), (result.result.organization_name) ? _c('div', [_c('small', [_vm._v(_vm._s(result.result.organization_name))])]) : _vm._e(), _c('div', [_c('small', [_vm._v(_vm._s(result.result.phone))])])])])]
      }
    }], null, false, 2676815204)
  }), _c('SearchEntity', {
    staticClass: "mb-1",
    attrs: {
      "entity": "drivers"
    },
    on: {
      "selected": function($event) {
        return _vm.gotoEntity($event, 'drivers')
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(result) {
        return [_c('div', {
          staticClass: "quick-search-result"
        }, [_c('div', [_c('small', [_vm._v("DR" + _vm._s(result.result.id))]), _c('div', [_vm._v(_vm._s(result.result.name) + " " + _vm._s(result.result.surname))]), _c('small', [_vm._v(_vm._s(result.result.mobile))])])])]
      }
    }], null, false, 2353354591)
  }), _c('SearchEntity', {
    staticClass: "mb-1",
    attrs: {
      "entity": "reservations"
    },
    on: {
      "selected": function($event) {
        return _vm.gotoEntity($event, 'reservations')
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(result) {
        return [_c('div', {
          staticClass: "quick-search-result"
        }, [_c('span', [_vm._v("R" + _vm._s(result.result.id))]), _c('span', [_vm._v(_vm._s(result.result.status))]), _c('small', [_vm._v(_vm._s(_vm.$dateFormat(result.result.start, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))) + " - " + _vm._s(_vm.$dateFormat(result.result.end, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('small', [_vm._v(_vm._s(result.result.vehicle.brand) + " " + _vm._s(result.result.vehicle.model) + " " + _vm._s(result.result.vehicle.plate))]), _c('small', [_vm._v("D" + _vm._s(result.result.driver.id) + " " + _vm._s(result.result.driver.name) + " " + _vm._s(result.result.driver.surname))])])]
      }
    }], null, false, 3601414489)
  }), _c('SearchEntity', {
    staticClass: "mb-1",
    attrs: {
      "entity": "vehicles"
    },
    on: {
      "selected": function($event) {
        return _vm.gotoEntity($event, 'vehicles')
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(result) {
        return [_c('div', {
          staticClass: "quick-search-result"
        }, [_c('span', [_vm._v("V" + _vm._s(result.result.id))]), _c('small', [_vm._v(_vm._s(result.result.brand) + " " + _vm._s(result.result.model) + " " + _vm._s(result.result.plate))]), _c('small', [_vm._v("PL" + _vm._s(result.result.parking_lot.id) + " " + _vm._s(result.result.parking_lot.name))])])]
      }
    }], null, false, 108632437)
  })], 1)])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d0de594a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/QuickSearch.vue
// module id = 2489
// module chunks = 1